import { css } from "@microsoft/fast-element";
import { DirectionalStyleSheetBehavior, display, forcedColorsStylesheetBehavior, } from "@microsoft/fast-foundation";
import { neutralFillRestBehavior, neutralForegroundRestBehavior, } from "@fluentui/web-components";
import { SystemColors } from "@microsoft/fast-web-utilities";
import { LuminanceStyleSheetBehavior } from "../utilities/luminance-behavior";
const ltr = css `
    :host::after {
        transform: translateX(-100%) translateX(20px);
    }
    :host([animate]) .label {
        transform: translateX(-100%);
    }
`;
const rtl = css `
    :host::after {
        transform: translateX(100%) translateX(-20px);
    }
    :host([animate]) .label {
        transform: translateX(100%);
    }
`;
const light = css `
    :host {
        color: #000;
    }
    :host::after {
        background: rgba(255, 255, 255, 0.46);
    }
`;
const dark = css `
    :host {
        color: #fff;
    }
    :host::after {
        background: rgba(0, 0, 0, 0.54);
    }
`;
export const ContentIndicatorStyles = css `
    ${display("inline-flex")} :host {
        align-items: center;
        box-sizing: border-box;
        contain: content;
        overflow: hidden;
    }

    .label-container {
        overflow: hidden;
    }

    :host,
    :host::after {
        ${ /* TODO: use corner-radius once Fluent vNext is a dependency -
      hard coding to 4px for now */""}
        border-radius: 4px;
    }

    :host::after {
        content: "";
        height: 100%;
        position: absolute;
        width: 100%;
        z-index: -1;
    }

    .icon-container,
    .label {
        min-height: 20px;
        min-width: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        fill: currentcolor;
    }

    :host([animate])::after,
    .label {
        transition: transform 250ms cubic-bezier(0.17, 0.17, 0, 1);
    }

    .label {
        font-family: var(--body-font);
        font-size: var(--type-ramp-minus-1-font-size);
        font-weight: 600;
        line-height: var(--type-ramp-minus-1-line-height);
        text-overflow: ellipsis;
        padding: 0 4px;
    }

    :host([expanded][animate])::after,
    :host([expanded][animate]) .label {
        transform: translateX(0);
    }

    ::slotted([slot="icon"]) {
        display: block;
        fill: currentcolor;
    }
`.withBehaviors(neutralFillRestBehavior, neutralForegroundRestBehavior, new DirectionalStyleSheetBehavior(ltr, rtl), new LuminanceStyleSheetBehavior(light, dark), forcedColorsStylesheetBehavior(css `
            :host {
                forced-color-adjust: auto;
            }
            ::slotted([slot="icon"]) {
                color: ${SystemColors.ButtonText};
                fill: currentcolor;
            }
            .icon-container,
            .label {
                background: ${SystemColors.ButtonFace};
                color: ${SystemColors.ButtonText};
                fill: currentcolor;
            }
        `));
